import { call, put, select } from 'redux-saga/effects';
import { saveMappingFailure, saveMappingSuccess } from '../actions';
import { ApiError } from 'store/api/types';
import { SaveMappingRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { PostMappingResponse, postMapping } from '../api';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn, updateMappingData } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import {
  fetchOrganisationsRequest,
  fetchOrganisationsSuccess,
  //postSaveRefreshMappinData,
} from 'store/organisation/actions';
import {
  getOrgMappings,
  getOrgOrganisations,
} from 'store/organisation/selectors';
import { push, replace } from 'store/navigation/actions';
import routes from 'routes';
import { renderErrorMessage } from 'utils/render-error-message';
import { isMaltaTifdReturnType } from 'utils/tifd-mapping';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* saveMappingSaga(action: SaveMappingRequestAction) {
  try {
    let err: ApiError | null;
    const {
      connectionId,
      mappingData,
      organisationId,
      redirectOrganisationId,
      stayOnPage = true,
    } = action.payload;

    const saveMappingResponse: PostMappingResponse = yield call(
      postMapping,
      connectionId,
      mappingData
    );

    err = checkResponse(saveMappingResponse?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: saveMappingResponse.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    const newMapping = saveMappingResponse.data.mapping;
    const orgs = yield select(getOrgOrganisations);
    const maps = yield select(getOrgMappings);
    if (mappingData.mappingId) {
      const idx = maps.findIndex((m) => m.mappingId === mappingData.mappingId);
      if (idx !== -1) {
        maps[idx] = newMapping;
      }
      //yield put(postSaveRefreshMappinData(mappingData));
    } else {
      if (maps.findIndex((m) => m.mappingId === newMapping.mappingId) === -1) {
        maps.push(newMapping);
        //yield put(fetchOrganisationsSuccess(orgs, maps));
      }
    }
    const createdMappingId =
      !mappingData.mappingId && newMapping?.mappingId
        ? newMapping.mappingId
        : undefined;
    if (createdMappingId) {
      yield put(
        updateMappingData({
          ...mappingData,
          mappingId: createdMappingId,
        })
      );
    }
    const isGroupContextSave =
      !!redirectOrganisationId && redirectOrganisationId !== organisationId;
    if (isGroupContextSave) {
      yield put(fetchOrganisationsRequest());
    } else {
      yield put(fetchOrganisationsSuccess(orgs, maps));
    }
    if (stayOnPage) {
      if (createdMappingId) {
        const editPath = (
          isMaltaTifdReturnType(mappingData.typeId)
            ? routes.returns.tifdEdit
            : routes.returns.edit
        )
          .replace(':connectionId', connectionId)
          .replace(':mappingId', createdMappingId);
        const search =
          typeof window !== 'undefined' ? window.location.search : '';
        yield put(replace({ pathname: editPath, search }));
      }
    } else {
      const targetOrganisationId = redirectOrganisationId || organisationId;
      yield put(
        push(
          routes.organisations.organisation.replace(':id', targetOrganisationId)
        )
      );
    }
    yield put(saveMappingSuccess());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(saveMappingFailure());
  }
}
